import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { AgreementModel } from '@fi-shared/fi-agreement/agreement.model';
import { AppTextService } from '@fi-shared/app-text';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiContentLanguageSharedService } from '@fi-shared/fi-content-language-shared/fi-content-language-shared.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { IVersionListColumn } from '@fi-app/utilities/versions-list/versions-list.component';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

@Component({
    selector: 'fi-agreement-versions-list',
    templateUrl: './agreement-versions-list.component.html',
    standalone: false,
})
export class FiAgreementVersionsListComponent implements OnInit, OnChanges {
    @Input() agreement: AgreementModel;
    @Input() languageId;

    publishedContent;
    versionsList;
    currentVersion;
    versionsFields: IVersionListColumn[];

    constructor(
        private appTextService: AppTextService,
        private stateService: FiStateService,
        private contentLanguageSharedService: FiContentLanguageSharedService,
        private fiFormatDateService: FiFormatDateService,
    ) {}

    ngOnInit() {
        this.updateContent();

        this.versionsFields = [
            {
                Name: 'AgreementVersion',
                Title: this.appTextService.get('common.version'),
                Content: (version) => {
                    let result = this.appTextService.get('common.version') + ' ' + version.AgreementVersion;
                    if (this.publishedContent.AgreementVersion == version.AgreementVersion) {
                        result += ' (' + this.appTextService.get('common.active_version') + ')';
                    }
                    return result;
                },
            },
            {
                Name: 'CreatedByUserName',
                Title: this.appTextService.get('user.user'),
            },
            {
                Name: 'CreatedOnDate',
                Title: this.appTextService.get('common.created_on'),
                Content: (version) => {
                    return this.fiFormatDateService.formatDate(version.CreatedOn, 'date');
                },
            },
        ];
    }

    versionClick(version) {
        if (version.AgreementVersion != this.publishedContent.AgreementVersion) {
            this.stateService.go(FiStateNames.Agreement.View.Version, {
                Id: this.agreement.Id,
                Version: version.AgreementVersion,
            });
        }
    }

    updateContent() {
        this.publishedContent = this.agreement.GetPublishedContentByContentLanguage(
            this.languageId,
            this.contentLanguageSharedService.getDefaultContentLanguageId(),
        );
        this.versionsList = this.agreement.AgreementVersions.filter(
            (version) => version.ContentLanguageId == this.publishedContent.ContentLanguageId,
        );
        this.currentVersion = this.agreement.GetVersion(
            this.publishedContent.AgreementVersion,
            this.publishedContent.ContentLanguageId,
        );
    }

    ngOnChanges() {
        this.updateContent();
    }
}
